export enum PrimaryUserRoles {
    DEVELOPER = 'developer',
    SUPERADMIN = 'superadmin',
    PLATFORM_ADMIN = 'platform_admin',
    FRONTOFFICE_MANAGER = 'frontoffice_manager',
    BACKOFFICE_MANAGER_CONDA = 'backoffice_manager_conda',
    BACKOFFICE_MANAGER_WL = 'backoffice_manager_wl',
    READ_ONLY = 'read_only',
}
